import styled, { css } from 'styled-components/macro'

import { IconInfoCircle } from '@loadsmart/icons'
import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

const flexCenteredStyle = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`

const activeStyle = css`
  opacity: 1;
`

const fadedStyle = css`
  opacity: 0.75 !important;

  pointer-events: none;
`

const loadingFadeStyle = css`
  ${({ isLoading }) => (isLoading ? fadedStyle : activeStyle)};
`

export const PanelSection = styled.div`
  ${flexCenteredStyle};
  ${loadingFadeStyle};
  padding: 28px 18px;
`

export const FullHeightStep = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
`

export const StepHeading = styled.div`
  width: ${({ block }) => (block ? 100 : 90)}%;
  margin-bottom: 10px;

  text-align: center;
`

export const StepTitle = styled.div`
  margin-bottom: 16px;

  color: ${({ success }) =>
    success ? getToken('color-primary') : getToken('color-neutral-darker')};
  font-weight: bold;
  font-size: 24px;
  line-height: 31px;
`

export const StepSubtitle = styled.div`
  color: ${getToken('color-neutral-dark')};
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
`

export const StepContent = styled.div`
  ${flexCenteredStyle};
  font-size: 15px;
  line-height: 20px;
  font-weight: 500;
  color: ${getToken('color-neutral-darkest')};
`

export const ReasonsList = styled.ul`
  width: 80%;
  margin-top: 16px;

  list-style-position: inside;
  list-style-type: bullet;

  li {
    list-style-position: inherit;
    list-style-type: inherit;
  }

  li :not(:first-child) {
    margin-top: 16px;
  }
`

export const StepFooter = styled.div`
  width: 100%;
  padding: 20px;

  background-color: ${getToken('color-neutral-lighter')};

  a {
    color: inherit;
    font-weight: bold;
    text-decoration: none;
  }
`

const bigIconStyle = css`
  width: 56px;
  height: 56px;
  margin-bottom: 18px;

  color: ${getToken('color-neutral-darker')};
`

export const BigIconExclamation = styled(IconInfoCircle)`
  ${bigIconStyle};
`
